import { baseApi } from "./baseApi";

export interface User {
  user_id: number;
  email: string;
  is_active: boolean;
  role_type: string;
  can_write: boolean;
  can_read: boolean;
  can_delete: boolean;
}

interface GetUsersResponse {
  success: boolean;
  data: User[];
}

export interface CreateUserResponse {
  success?: boolean;
  message: string;
  user?: {
    email: string;
    role_id: number;
    password?: string;
  };
}

export interface UpdateUserResponse {
  success: boolean;
  message: string;
  user?: {
    email: string;
    role_id: number;
    password?: string;
    emp_id?: string;
    username?: string;
  };
}

interface LoginResponse {
  success: boolean;
  token: string;
  message?: string;
  user: User;
}

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, { email: string; password: string }>({
      query: (credentials) => ({
        url: "/login",
        method: "POST",
        body: credentials,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          if (data.token) {
            localStorage.setItem("token", data.token);
            dispatch({ type: "auth/loginSuccess", payload: data.user });
          }
        } catch (err) {
          console.error("Login failed:", err);
        }
      },
      invalidatesTags: ["Auth"],
    }),

    forgotPassword: builder.mutation<
      { success: boolean; message: string },
      { email: string }
    >({
      query: ({ email }) => ({
        url: "/forgot-password",
        method: "POST",
        body: { email },
      }),
    }),
    resetPassword: builder.mutation<
      { success: boolean; message: string },
      { password: string; confirmPassword: string }
    >({
      query: ({ password, confirmPassword }) => ({
        url: "/reset-password",
        method: "POST",
        body: { password, confirmPassword },
      }),
    }),

    getUsers: builder.query<User[], void>({
      query: () => "/user/list",
      transformResponse: (response: GetUsersResponse) => response.data,
      providesTags: ["User"],
    }),

    createUser: builder.mutation<
      CreateUserResponse,
      { email: string; role_id: number; emp_id?: string; username?: string; password?: string }
    >({
      query: ({ email, role_id, emp_id, username, password }) => ({
        url: "/user/create",
        method: "POST",
        body: { email, role_id, emp_id, username, password },
      }),
      invalidatesTags: ["User"],
    }),

    updateUser: builder.mutation<
      UpdateUserResponse,
      { id?: number; role_id?: number; password?: string }
    >({
      query: ({ id, role_id, password }) => ({
        url: `/user/update/${id}`,
        method: "PUT",
        body: { role_id, password },
      }),
      invalidatesTags: ["User"],
    }),
    deleteUser: builder.mutation<{ success: boolean; message: string }, number>({
      query: (id) => ({
        url: `/user/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["User"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useLoginMutation,
  useGetUsersQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation
} = authApi;


